import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/lib/i18n";
import HomePage from "@/pages/HomePage";
import AdminPage from "@/pages/AdminPage";
import LegalPage from "@/pages/LegalPage";
import InsightsPage from "@/pages/InsightsPage";
import InsightDetail from "@/pages/InsightDetail";
import CommodityPage from "@/pages/CommodityPage";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/legal/:doc" element={<LegalPage />} />
          <Route path="/insights" element={<InsightsPage />} />
          <Route path="/insights/:id" element={<InsightDetail />} />
          <Route path="/commodities/:slug" element={<CommodityPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
      </LanguageProvider>
      <WhatsAppFloat />
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
